export default {
	data() {
		return {
			change: false,
		}
	},
	computed: {
		avance() {
			let size = Object.keys(this.datos).length
			let keyPercentage = 100 / size
			let total = 0
			for (const key in this.datos) {
				if(this.datos[key] != '') {
					total += keyPercentage
				}
			}

			return total <= 100 ? Math.round(total) : 100
		}
	},
	methods: {

		save(avance = null) {
			let datos = JSON.stringify(this.datos)
				datos = JSON.parse(datos)
			this.$emit('save', {
				nombre: this.name,
				datos: datos,
				avance: avance !== null ? avance : this.avance
			})
			document.querySelector('html').scrollTop = 0
		}
	},
}